import * as yup from 'yup'

export const authSchema = yup.object().shape({
  username: yup.string().required(),
  password: yup.string().required(),
})

export const resetPasswordSchema = yup.object().shape({
  password: yup.string().required('Password is required'),
  confirmPassword: yup
    .string()
    .required('Please confirm your password')
    .oneOf([yup.ref('password')], 'Passwords must match'),
})